import { Normalization } from '~/utils/normalization'

export const enumOrRaw = <Member extends string>(
  value: unknown,
  members: readonly Member[]
): unknown => Normalization.enumValue(value, members, value)
